module.exports = __webpack_public_path__ + "img/icon_mobileApp1.6659ba2a.png";